import { z } from 'zod';

// Schema for validating environment variables
const envSchema = z.object({
  VITE_SUPABASE_URL: z.string().url('Invalid Supabase URL'),
  VITE_SUPABASE_ANON_KEY: z.string().min(1, 'Missing Supabase anon key'),
  VITE_MICROSOFT_CLIENT_ID: z.string().min(1, 'Missing Microsoft client ID'),
  VITE_APP_URL: z.string().url('Invalid app URL'),
});

// Parse and validate environment variables
export function validateEnv() {
  try {
    const env = {
      VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
      VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
      VITE_MICROSOFT_CLIENT_ID: import.meta.env.VITE_MICROSOFT_CLIENT_ID,
      VITE_APP_URL: import.meta.env.VITE_APP_URL,
    };
    
    return envSchema.parse(env);
  } catch (error) {
    console.error('Environment validation failed:', error);
    throw new Error('Missing or invalid environment variables');
  }
}

// Export the validated environment
let validatedEnv = null;
try {
  validatedEnv = validateEnv();
  console.log('Environment validation successful');
} catch (error) {
  console.error('Failed to initialize environment:', error);
}

export const env = validatedEnv;
